<template>
  <div>
    <b-container class="home-container container-xl vali-hollow-logo">
      <b-row col="12" class="mb-5">
        <b-col sm="12" md="12" lg="8" xl="6" style=" font-size: 18px; text-align: left">
          <h1 class="text-left">A személyre szabott vállalkozói információ</h1>
          <p class="text-left mt-4" style="font-size: 24px">
            Tájékozódjon a vállalkozása számára elérhető támogatásokról, hitelekről, képzési és szakértői
            szolgáltatásokról.
          </p>
        </b-col>
      </b-row>
      <ifka-vp-energy-support-program-section />
      <b-row col="12" class="mb-2 mt-0 justify-content-md-center text-left">
        <b-col sm="12" md="12" lg="12" xl="12">
          <h2>
            Böngésszen regisztráció nélkül
          </h2>
        </b-col>
      </b-row>
      <b-row col="12" class="mb-2 justify-content-md-center">
        <b-col cols="12">
          <ifka-vp-search-company />
        </b-col>
      </b-row>

      <ifka-vp-login-banner />
      <ifka-vp-programs />
      <ifka-vp-services />
      <ifka-vp-programs-highlight />
      <ifka-vp-news />

      <div class="opacity-logo">
        <b-img src="../assets/img/logo/vekonylogo_vali_horisontal.svg" class="mt-4 mb-4" />
      </div>
    </b-container>
    <EuropeanAward />
  </div>
</template>

<script>
import ConstantServices from '@/components/ConstantServices.vue'
import LoginBanner from '@/components/LoginBanner.vue'
import News from '@/components/News.vue'
import Programs from '@/components/Programs.vue'
import ProgramsHighlight from '@/components/ProgramsHighlight.vue'
import SearchCompany from '@/components/SearchCompany.vue'
import DSPHeadLine from '../components/DSPHeadLine.vue'
import EuropeanAward from '../components/EuropeanAward.vue'

export default {
  name: 'Home',
  components: {
    ifkaVpSearchCompany: SearchCompany,
    ifkaVpNews: News,
    ifkaVpPrograms: Programs,
    ifkaVpServices: ConstantServices,
    ifkaVpProgramsHighlight: ProgramsHighlight,
    ifkaVpLoginBanner: LoginBanner,
    ifkaVpEnergySupportProgramSection: DSPHeadLine,
    EuropeanAward
  }
}
</script>

<style scoped>
@media (min-width: 992px) {
  .vali-hollow-logo {
    position: relative;
    overflow: hidden;
  }

  .vali-hollow-logo:before {
    content: ' ';
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    opacity: 0.2;
    background-image: url('../assets/img/logo/vekonyvali_hollow.svg');
    background-repeat: no-repeat;
    background-position: 100% 0;
    background-size: 394px;
  }

  .opacity-logo {
    width: 312px;
    max-width: 312px;
    margin: 0 auto;
    opacity: 0.6;
  }
}
</style>
